import CSV from 'comma-separated-values';

export default function (data, filename, options) {
  const csv = `data:text/csv;charset=utf-8,${CSV.encode(data, options)}`;
  const link = document.createElement('a');

  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', filename || 'export.csv');
  link.click();
}
